import { Card } from "@mui/material";
import { Cols } from "../../shared/Consts";
import Holding from "../../models/Holding";
import KeyVal from "../../components/KeyVal";

export default function SummaryAsset(props:{holding:Holding}) {
    return <Card className="historySummary">
        <KeyVal label="Qty" value={props.holding.value(Cols.quantity)}/>
        <KeyVal label="Avg" value={props.holding.value(Cols.averagePrice)}/>
        <KeyVal label="Price" value={props.holding.value(Cols.currentPrice)}/>
        <KeyVal label="Value" value={props.holding.value(Cols.holdingValue)}/>
        <KeyVal label="A.Div" value={props.holding.value(Cols.a_payout)}/>
        <KeyVal label="Dividend" value={props.holding.value(Cols.dividend)} className={props.holding.className(Cols.dividend)}/>
        <KeyVal label="Gain" value={props.holding.value(Cols.gain)} className={props.holding.className(Cols.gain)}/>
        <KeyVal label="Performance" value={props.holding.value(Cols.mwPercent)} className={props.holding.className(Cols.mwPercent)}/>
    </Card>
}